import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '@components/ui/Header';
import { useStatamicContent } from '@utils/useStatamicContent';
import HeroSection from './components/HeroSection';
import VisionAssessmentTool from './components/VisionAssessmentTool';
import TestimonialCarousel from './components/TestimonialCarousel';
import ServicesPreview from './components/ServicesPreview';
import TrustSignals from './components/TrustSignals';
import EmergencyPortal from './components/EmergencyPortal';
import LiveChatWidget from './components/LiveChatWidget';
import Footer from '@components/ui/Footer';

const Homepage = () => {

  // Fetch home page content using slug "home"
  const { data: page, loading, error } = useStatamicContent('pages/home');

  useEffect(() => {
   // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Cleanup
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{page?.seo_title || "Eye&U Kenya - Your Vision, Our Mission | Premium Eye Care in East Africa"}</title>
        <meta name="description" content={page?.meta_description || "Experience world-class eye care with Kenyan warmth. From LASIK surgery to pediatric care, Eye&U Kenya offers comprehensive vision solutions with 98% success rate. Book your consultation today."} />
        <meta name="keywords" content={page?.meta_keywords || "eye care Kenya, LASIK surgery Nairobi, cataract surgery, diabetic eye care, pediatric ophthalmology, glaucoma treatment, emergency eye care, vision correction Kenya"} />
        <meta property="og:title" content={page?.og_title || "Eye&U Kenya - Premium Eye Care | Your Vision, Our Mission"} />
        <meta property="og:description" content={page?.og_description || "East Africa's leading eye care authority. 50,000+ patients treated, 98% success rate, 4.9/5 rating. Experience the difference at Eye&U Kenya."} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={page?.og_url || "https://eyenu.com/homepage-premium-healthcare-digital-experience"} />
        <link rel="canonical" href={page?.canonical_url || "https://eyenu.com/homepage-premium-healthcare-digital-experience"} />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          {/* Hero Section with Interactive Slider */}
          <HeroSection />
          
          {/* Interactive Vision Assessment Tool */}
          <VisionAssessmentTool />
          
          {/* Patient Success Stories Carousel */}
          <TestimonialCarousel />
          
          {/* Services Overview Grid */}
          <ServicesPreview />
          
          {/* Trust Signals & Certifications */}
          <TrustSignals />
          
          {/* Emergency Care Portal 
          <EmergencyPortal /> */}
        </main>

        <Footer />
        {/* <LiveChatWidget /> */}
      </div>
    </>
  );
};

export default Homepage;